import React, { useState, useEffect } from 'react';
import './MobileFilterSort.css';
import { ReactComponent as CategoryIcon } from '../../../assets/Blog/Blog home/Category.svg';
import { ReactComponent as SortIcon } from '../../../assets/Blog/Blog home/sort.svg';

const MobileFilterSort = ({ selectedTab, setSelectedTab, selectedCategory, setSelectedCategory,categories }) => {
  const [isCategoryOpen, setIsCategoryOpen] = useState(false);
  const [isTabOpen, setIsTabOpen] = useState(false);
  
  const handleTabChange = (tab) => {
    if (selectedTab === tab) {
      setSelectedTab(''); // Unselect if already selected
    } else {
      setSelectedTab(tab); // Set new tab
    }
    setIsTabOpen(false);
  };

  const handleCategoryChange = (category) => {
    if (selectedCategory === category) {
      setSelectedCategory(''); // Unselect if already selected
    } else {
      setSelectedCategory(category); // Set new category
    }
    setIsCategoryOpen(false);
  };

  const closeDropdowns = () => {
    setIsTabOpen(false);
    setIsCategoryOpen(false);
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.mobile-filter-sort')) {
        closeDropdowns();
      }
    };
    if (isTabOpen || isCategoryOpen) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isTabOpen, isCategoryOpen]);

  return (
    <div className="mobile-filter-sort">
      {/* Backdrop for blurring when dropdown is open */}
      {(isTabOpen || isCategoryOpen) && <div className="backdrop" onClick={closeDropdowns}></div>}

      {/* Category button with dropdown */}
      <button
        className={`mobile-category-button ${selectedCategory ? 'selected' : ''}`}
        onClick={() => setIsCategoryOpen(!isCategoryOpen)}
      >
        <CategoryIcon className="icon-category" />
        Categories
      </button>
      
      {/* Sort button with dropdown */}
      <button
        className={`mobile-tab-button ${selectedTab ? 'selected' : ''}`}
        onClick={() => setIsTabOpen(!isTabOpen)}
      >
        <SortIcon className="icon-sort" />
        Sort
      </button>
      
      {isTabOpen && (
        <div className="mobile-tab-options">
          <button onClick={() => handleTabChange('Latest')} className={selectedTab === 'Latest' ? 'selected' : ''}>Latest</button>
          <button onClick={() => handleTabChange('Trending')} className={selectedTab === 'Trending' ? 'selected' : ''}>Trending</button>
        </div>
      )}

      {isCategoryOpen && (
        <div className="mobile-category-options">
          <button onClick={() => handleCategoryChange('')} className={selectedCategory === '' ? 'selected' : ''}>All</button>
          {categories.map((category) => (
            <button 
              key={category} 
              onClick={() => handleCategoryChange(category)} 
              className={selectedCategory === category ? 'selected' : ''}
            >
              {category}
            </button>
          ))}
        </div>
      )}

    </div>
  );
};

export default MobileFilterSort;
